var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 11.67"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1027.57 -1503.465)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.98,
    height: 11.67,
    rx: 0.973,
    transform: "translate(-1025.894 1503.465)",
    fill: "#4a4a4a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.75,
    d: "M-1027.57 1511.147h18"
  }))));
}
export default __webpack_public_path__ + "15e2ed243796d82b8446af236f3e58ec.svg";
export { SvgCardIcon as ReactComponent };